<template lang="pug">
#bloco-pesquisa-inteligente-filtros-contrato
    .filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    placeholder='Busque pelo número do contrato',
                    autocomplete='off',
                    @keyup.enter='aplicarFiltros'
                    @input='limpar'
                )
        .filtros-data
            el-date-picker(
                v-model="dataSelecionada"
                class="input-data-cadastro"
                type="date"
                format="dd-MMMM-yyyy"
                placeholder="Data de contrato"
                @change="aplicarFiltros")

        .filtros-avancados
            el-popover(placement='bottom', width='500', trigger='click' @show="obterDadosFiltro")
                BaseButton.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) Filtros avançados

                el-form.filtro-contrato(label-position='top')
                    .filtros-avancados__cabecalho__cadastro.mb-3
                        .filtros-avancados__titulo
                            b Filtros avançados
                        .filtros-avancados__aplicar-filtro__cadastro(
                            @click='aplicarFiltros'
                        )
                            | Aplicar filtro

                    .filtros-avancados__collapse
                        el-form-item
                            el-collapse(
                                v-model='collapseCulturaAtivo'
                                v-show="false"
                            )
                                el-collapse-item(
                                    title='Cultura',
                                    name='cultura'
                                )
                                        el-checkbox-group( v-model="culturaSelecionada" class="alinhamento-cultura" v-loading='carregandoCultura')
                                            el-checkbox( v-for="cultura in culturas"
                                                        :label="cultura.nome"
                                                        :key="cultura.id"
                                                        :value="cultura.id"
                                                        ) {{ cultura.nome }}

                            el-collapse(
                                v-model='collapseSafraAtivo'
                            )
                                el-collapse-item(title='Safra', name='safra')
    
                                        el-checkbox-group( v-model="safraSelecionada" class="alinhamento-safra" v-loading='carregandoSafra')
                                            el-checkbox( v-for="safra in safras"
                                                        :label="safra.descricao"
                                                        :key="safra.id"
                                                        :value="safra.descricao"
                                                        ) {{ safra.descricao }}
                            
                            el-collapse(
                                v-model='collapseStatusAtivo'
                            )
                                el-collapse-item(title='Status', name='status')
                                    el-checkbox-group( v-model="statusSelecionado" class="alinhamento-status" v-loading='carregandoStatusEmpresa')
                                                el-checkbox( v-for="status in statusEmpresa"
                                                            :label="status.descricao"
                                                            :key="status.codigo"
                                                            :value="status.descricao"
                                                            ) {{ status.descricao }}

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados.mt-3
        span.filtros-selecionados__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtros-selecionados__tags(
            v-for='(tag, index) in tags',
            :key='index',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) Limpar filtros
            i.el-icon-delete

        span.filtros-selecionados__vazio(v-else) Nenhum filtro selecionado
</template>

<script>
import ServiceRastreabilidadeEmpresa from '@/services/RastreabilidadeEmpresa';
import UtilsService from '@/services/UtilsService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'BlocoPesquisaInteligenteFiltros',
    components: {
        BaseButton
    },
    emits: ['emitFiltros'],
    data() {
        return {
            tags: [],
            culturaSelecionada: [],
            safraSelecionada: [],
            statusSelecionado: [],
            collapseCulturaAtivo: ['cultura'],
            collapseSafraAtivo: ['safra'],
            collapseStatusAtivo: ['status'],
            dataSelecionada: '',
            pesquisa: '',
            culturas: [],
            safras: [],
            statusEmpresa: [],
            carregandoCultura: false,
            carregandoStatusEmpresa: false,
            carregandoSafra: false
        };
    },
    methods: {
        aplicarFiltros() {
            this.tags = [];
            if (this.culturaSelecionada.length) this.tags.push(...this.culturaSelecionada);
            if (this.safras.length) this.tags.push(...this.safraSelecionada);
            if (this.statusSelecionado.length) this.tags.push(...this.statusSelecionado);
            if (this.dataSelecionada) this.tags.push('Data de cadastro');

            const filtro = {
                culturas: this.obterIdsCultura(),
                safras: this.obterIdsSafra(),
                status: this.obterIdsStatus(),
                dataCadastro: this.converterData(),
                pesquisa: this.obterPesquisa()
            };
            this.$emit('emitFiltros', filtro);
        },
        converterData() {
            if (!this.dataSelecionada) return '';
            return new Date(this.dataSelecionada).getTime();
        },
        obterIdsStatus() {
            if (!this.statusSelecionado) return [];
            return this.statusSelecionado.map(descricao => {
                    const statusObjeto = this.statusEmpresa.find(objeto => objeto.descricao === descricao);
                    return statusObjeto ? statusObjeto.codigo : null;
                });
        },
        obterIdsCultura() {
            if (!this.culturaSelecionada) return [];
            return this.culturaSelecionada.map(nome => {
                    const statusObjeto = this.culturas.find(objeto => objeto.nome === nome);
                    return statusObjeto ? statusObjeto.id : null;
                });
        },
        obterIdsSafra() {
            if (!this.safraSelecionada) return [];
            return this.safraSelecionada.map(descricao => {
                    const statusObjeto = this.safras.find(objeto => objeto.descricao === descricao);
                    return statusObjeto ? statusObjeto.id : null;
                });
        },
        obterPesquisa() {
            if (!this.pesquisa) return '';
            return this.pesquisa;
        },
        limparFiltros() {
            this.tags = [];
            this.culturaSelecionada = [];
            this.safraSelecionada = [];
            this.statusSelecionado = [];
            this.dataSelecionada = '';
            this.pesquisa = '';
            this.aplicarFiltros();
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            const indexCultura = this.culturaSelecionada.indexOf(filtro);
            if (indexCultura !== -1) {
                this.culturaSelecionada.splice(indexCultura, 1);
            }

            const indexSafra = this.safraSelecionada.indexOf(filtro);
            if (indexSafra !== -1) {
                this.safraSelecionada.splice(indexSafra, 1);
            }

            const indexStatus = this.statusSelecionado.indexOf(filtro);
            if (indexStatus !== -1) {
                this.statusSelecionado.splice(indexStatus, 1);
            }

            if (filtro === 'Data de cadastro') {
                this.dataSelecionada = '';
            }
        },
        formatarData(data, formatDate) {
            if (data) {
                const dia = formatDate(data, 'dd');
                const mes = formatDate(data, 'MM');
                const ano = formatDate(data, 'yyyy');
                return `${dia}, ${mes}, ${ano}`;
            }
            return '';
        },
        limpar() {
            if (this.pesquisa === '') this.aplicarFiltros();
        },
        obterDadosFiltro() {
            if (this.culturas.length && this.statusEmpresa.length && this.safras.length) return;
            this.getStatusEmpresa();
            this.getCulturas();
            this.getSafras();
        },
        async getStatusEmpresa() {
            this.carregandoStatusEmpresa = true;
            try {
                const { data } = await ServiceRastreabilidadeEmpresa.statusSubEmpresa();
                this.statusEmpresa = data;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível buscar os dados de status.'
                });
            }
            this.carregandoStatusEmpresa = false;
        },
        async getCulturas() {
            this.carregandoCultura = true;
            try {
                const { data } = await UtilsService.getCulturas();
                this.culturas = data;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de cultura.'
                });
            }
            this.carregandoCultura = false;
        },
        async getSafras() {
            this.carregandoSafra = true;
            try {
                const { data } = await UtilsService.getSafras();
                this.safras = data;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de safras.'
                });
            }
            this.carregandoSafra = false;
        }
    }
};
</script>

<style lang="scss">
#bloco-pesquisa-inteligente-filtros-contrato {
    .filtros {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        gap: 10px;
    }

    .pesquisa-inteligente__container {
        width: 100%;
        height: 42px;
        border-radius: 5px;
        background: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
    }
    .filtros-data {
        box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
    }
    .input-data-cadastro {
        .el-input__inner {
            height: 43px !important;
        }
    }
    .pesquisa-inteligente__barra-pesquisa {
        height: 100%;
        display: flex;
        justify-content: center;

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .pesquisa-inteligente__resultado {
        position: absolute;
        width: 100%;
    }

    .pesquisa-inteligente__ul {
        list-style: none;
        padding: 8px 0 8px 24px;
        position: relative;
        z-index: 42;
        margin-top: 5px;
        border-radius: 5px;
        background-color: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

        li {
            padding-left: 18px;
            margin-top: 5px;
            cursor: pointer;
        }
    }

    .pesquisa-inteligente__categoria {
        font-weight: bold;
    }

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-wrap: wrap;
    }

    .filtros-selecionados__limpar {
        cursor: pointer;
    }
}
.filtro-contrato {
    .filtros-avancados__cabecalho__cadastro {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .filtros-avancados__titulo {
        color: var(--primary);
    }

    .filtros-avancados__aplicar-filtro__cadastro {
        cursor: pointer;
        border-radius: 20px;
        padding: 4px 8px;
        color: #1989FA;
        text-decoration: underline;
    }
    .filtros-avancados__aplicar-filtro__cadastro:hover {
        color: var(--secondary);
    }
    .alinhamento-cultura, .alinhamento-safra, .alinhamento-status {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 8px;
    }
    .alinhamento-status {
        .el-checkbox {
            width: 233px;
        }
    }
}
</style>
